import { render } from "./RecapitulatifInscription.vue?vue&type=template&id=60f5e6e6&scoped=true"
import script from "./RecapitulatifInscription.vue?vue&type=script&lang=js"
export * from "./RecapitulatifInscription.vue?vue&type=script&lang=js"

import "./RecapitulatifInscription.vue?vue&type=style&index=0&id=60f5e6e6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f5e6e6"]])

export default __exports__